import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 增值服务列表
export const setOrgModules: Mutation<IModuleState> = (state, payload) => {
  state.modules.data = payload.data;
  state.modules.loading = !!payload.loading;
};

// 未设置的增值服务列表
export const setOrgUnModules: Mutation<IModuleState> = (state, payload) => {
  state.unModules.data = payload.data;
  state.unModules.loading = !!payload.loading;
};

// 弹窗
export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.name = payload.name;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = !!payload;
};
